import React from "react";
import VisaCard from "./VisaCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/pro-regular-svg-icons";
import MasterCard from "./MasterCard";
import Amex from "./Amex";
import Discover from "./Discover";
import JBC from "./JCB";
import DinersClub from "./DinersClub";
import Interac from "./Interac";

export type PaymentMethodBrand =
  | "interac"
  | "visa"
  | "mastercard"
  | "discover"
  | "amex"
  | "jcb"
  | "diners";

interface IProps {
  brand?: string | null;
  size?: "sm" | "md" | "lg";
}

export function normalizePaymentMethodBrand(brand?: string | null): PaymentMethodBrand | null {
  const key = (brand || "").toLowerCase().replace(/[\s_-]+/g, "");
  if (key === "visa") {
    return "visa";
  }
  if (key === "mastercard" || key === "mc") {
    return "mastercard";
  }
  if (key === "amex" || key === "americanexpress") {
    return "amex";
  }
  if (key === "discover") {
    return "discover";
  }
  if (key === "jcb") {
    return "jcb";
  }
  if (key === "diners" || key === "dinersclub") {
    return "diners";
  }
  if (key === "interac") {
    return "interac";
  }
  return null;
}

export default function PaymentMethodIcon(props: IProps) {
  const { brand, size = "sm" } = props;
  const normalized = normalizePaymentMethodBrand(brand);

  switch (normalized) {
    case "visa":
      return <VisaCard size={size} />;
    case "mastercard":
      return <MasterCard size={size} />;
    case "amex":
      return <Amex size={size} />;
    case "discover":
      return <Discover size={size} />;
    case "jcb":
      return <JBC size={size} />;
    case "diners":
      return <DinersClub size={size} />;
    case "interac":
      return <Interac size={size} />;
    default:
      return <FontAwesomeIcon icon={faCreditCard} />;
  }
}
